/*
 * @name: 产品与服务
 * @
 * @Author: 黄晓玲
 * @Date: 2022-12-01 10:13:58
 * @LastEditors: 黄晓玲
 * @LastEditTime: 2022-12-02 15:46:21
 * @Description: 描述
 */
<template>
  <div>
    <div>
      <img
        class="backImg"
        :src="
          language === 'zh'
            ? require('@/assets/images/productCenter/backgroundImg.jpg')
            : require('@/assets/images/productCenter/en_backgroundImg.jpg')
        "
      />
    </div>
    <div class="bread">
      <el-row :gutter="0" type="flex" justify="center">
        <el-col :xs="24" :sm="21" :md="20" :lg="18" :xl="16">
          <slot name="breadcrumb"></slot>
        </el-col>
      </el-row>
    </div>
    <div class="container">
      <productCenter ref="productCenter"></productCenter>
    </div>
  </div>
</template>

<script>
import productCenter from "@/views/productCenter/productCenter";
import { localStorage } from "../../utils/storage";
export default {
  components: { productCenter },
  data() {
    return {
      language: localStorage.get("language") || "zh",
    };
  },
  created() {},

  methods: {},
};
</script>

<style scoped>
.backImg {
  width: 100%;
}
.bread {
  background-color: #f6f6f6;
  padding: 15px 20px;
}
.container {
  padding: 20px;
}
@media only screen and (max-width: 768px) {
  .backImg {
    width: 100%;
    height: auto;
  }
}
</style>